import { useEffect, useState } from "react";
import { readPage, readRouteParams, subscribeNavigation } from "../navigation";
import type { Page } from "../navigation";

export function usePageParams(page: Page) {
  const [params, setParams] = useState(readRouteParams);
  useEffect(() => subscribeNavigation(() => {
    if (readPage() === page) setParams(readRouteParams());
  }), [page]);
  return params;
}

export function routeId(value: string | null): string | null {
  return value && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value) ? value.toLowerCase() : null;
}

export function routeChoice(value: string | null, choices: readonly string[], fallback = "") {
  return value && choices.includes(value) ? value : fallback;
}

export function routePage(value: string | null) {
  return value && /^[1-9]\d*$/.test(value) && Number.isSafeInteger(Number(value)) ? Number(value) : 1;
}
